<template>
  <div class="panel-body">
    <div id="shipping-status-inquiry" class="flexbox gap-15 flex-content-start" style="flex-wrap: nowrap;">
      <div class="filter">
        <form autocomplete="off"  class="w-210">
          <span class="control-label label-normal">区分</span><br>
          <div class="pd-l-10 pd-t-10">
            <div v-for="item in shippingKbnOption" :key="item.value" class="form-check">
              <input type="checkbox" name="shippingKbn" :value="item.value" class="form-check-input" :id="'shippingKbn-' + item.value"
                v-model="filter.shippingKbn">
              <label class="form-check-label" :for="'shippingKbn-' + item.value">{{ item.label }}</label>
            </div>
          </div>
          <div class="form-group">
            <label class="control-label label-normal">出荷管理番号</label>
            <input type="text" class="form-control" v-model.trim="filter.shippingNo" @keydown.enter="filterShipping">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">出荷ID</label>
            <input type="text" class="form-control" v-model.trim="filter.shippingId" @keydown.enter="filterShipping">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">ASIN</label>
            <input type="text" class="form-control" v-model.trim="filter.asin" @keydown.enter="filterShipping">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">SKU</label>
            <input type="text" class="form-control" v-model.trim="filter.sku" @keydown.enter="filterShipping">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">商品ラベル</label>
            <input type="text" class="form-control" v-model.trim="filter.fnsku" @keydown.enter="filterShipping">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">出荷依頼日</label>
            <date-picker
              v-model="filter.createDate"
              placeholder=""
              ref="datepickerStart"
              format="YYYY/MM/DD"
              :input-attr="{id: 'create-date'}"
              :lang="lang"
            ></date-picker>
          </div>
          <span class="control-label label-normal">出荷ステータス</span><br>
          <div class="pd-l-10 pd-t-10">
            <div v-for="item in wareHouseStatusOption" :key="item" class="form-check">
              <input type="checkbox" name="warehouseStatus" :value="item" class="form-check-input" :id="'warehouseStatus-' + item"
                v-model="filter.warehouseStatus">
              <label class="form-check-label" :for="'warehouseStatus-' + item">{{ item }}</label>
            </div>
          </div>
          <span class="control-label label-normal">表示</span><br>
          <div class="pd-l-10 pd-t-10">
            <div class="form-check">
              <input type="checkbox" name="warehouseStatus" class="form-check-input" id="show-delete-item-ckb"
                v-model="filter.isShowDelete">
              <label class="form-check-label" for="show-delete-item-ckb">削除明細を表示する</label>
            </div>
          </div>
          <div class="flexbox gap-10 mr-t-15">
            <button type="button" class="btn btn-primary w-100" @click="filterShipping">検索</button>
            <button type="button" class="btn w-100" @click="clearFilter">クリア</button>
          </div>
        </form>
      </div>
      <div class="">
        <div class="flexbox justify-between count">
          <span class="count">{{ pageData.length }} 件</span>
          <div class="flexbox gap-20">
            <span class="count">(注) Amazon倉庫への出荷について、出荷登録直後は明細が表示されません。しばらくたってからご確認ください。</span>
            <pagination
              :totalPage="totalPage"
              :currentPage="currentPage"
              :paginationStorageKey="paginationStorageKey"
              @updateCurrentPage="updateCurrentPage"
            />
          </div>
        </div>
        <div class="table-outter">
          <div class="table-header">
            <table class="">
              <thead>
                <tr>
                  <th class="w-120"></th>
                  <th class="text-left w-180">区分</th>
                  <th class="text-left w-250">出荷管理番号（出荷ID）</th>
                  <th class="text-left w-300">出荷名（依頼番号）</th>
                  <th class="text-left w-160">出荷依頼日（出荷日）</th>
                  <th class="text-left w-150">出荷ステータス</th>
                  <th class="w-270"></th>
                </tr>
              </thead>
            </table>
          </div>
          <div v-if="displayData.length > 0" v-for="(item, index) in displayData" :key="index" class="table-group mr-t-15" :class="{ 'deleted': item.isDeleted }"
              :id="'table-group-' + item.shippingId + '-' + item.shippingNo">
            <table style="table-layout: fixed;">
              <tbody>
                <tr>
                  <td class="text-center w-120">
                    <button class="btn btn-expand w-100" data-toggle="collapse" :id="'btn-expand-' + item.shippingId + '-' + item.shippingNo" :data-target="'#' + item.shippingId + '-' + item.shippingNo" @click="handleExpand(item.shippingId, item.shippingNo)" :disabled="item.shippingGoods.length === 0">
                      <i class="fa fa-plus" aria-hidden="true"></i> 開く
                    </button>
                    <button class="btn btn-collapse w-100 hidden" data-toggle="collapse" :id="'btn-collapse-' + item.shippingId + '-' + item.shippingNo" :data-target="'#' + item.shippingId + '-' + item.shippingNo" @click="handleCollapse(item.shippingId, item.shippingNo)">
                      <i class="fa fa-minus" aria-hidden="true"></i> 閉じる
                    </button>
                  </td>
                  <td class="text-left w-180">
                    {{ getShippingKbnText(item.shippingKbn) }}
                  </td>
                  <td class="text-left w-250">
                    {{ item.shippingNo }} <br>
                    ({{ item.shippingId }})
                  </td>
                  <td class="text-left w-300" style="word-break: break-all;">
                    {{ item.shippingName }} <br>
                    {{ item.requestNo && "(" + item.requestNo + ")" }}
                  </td>
                  <td class="text-left w-160">
                    {{ formatDate(item.createDate) }} <br>
                    {{ item.shippingDate && '(' + formatDate(item.shippingDate) + ')' }}
                  </td>
                  <td class="text-size-16 text-left w-150">
                    <span :class="getStatusTextClass(item.status)">
                      {{ item.status }}
                    </span>
                    <div v-if="checkStatus(item.status)" class="shipping-status" :class="getStatusClass(item.status)"></div>
                  </td>
                  <td class="text-left w-270">
                    <div class="flexbox gap-5 justify-right">
                      <button type="button" class="btn btn-primary w-80 check-maintenace" @click="openModalDeliveyInfo(item)">出荷情報</button>
                      <div class="btn-group">
                        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                          操作
                          <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu" role="menu" @click.stop>
                          <li class="check-maintenance" :class="item.disableEdit ? 'disabled' : ''" :disabled="item.disableEdit" @click="handleEdit(item)">編集する</li>
                          <li class="check-maintenance" :class="item.disableCopy ? 'disabled' : ''" :disabled="item.disableCopy" @click="openConfirmCoppyModal(item)">複製する</li>
                          <li class="check-maintenance" :class="item.disableDelete ? 'disabled' : ''" :disabled="item.disableDelete" @click="openConfirmDeleteModal(item)">削除する</li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="item.shippingGoods.length" :id="item.shippingId + '-' + item.shippingNo" class="collapse table-item" style="background-color: #fff; margin: 0 10px 10px 10px;">
              <table class="full-width" style="table-layout: fixed;">
                <thead>
                  <tr>
                    <th class="text-center w-150">出荷する商品</th>
                    <th></th>
                    <th class="text-right w-150">出荷予定数</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="product in item.shippingGoods" :key="product.itemId">
                    <td class="text-center w-150">
                        <div v-if="product.image" class="box-selected-product-image w-50">
                            <img loading="lazy" :src="product.image"
                                alt="" class="selected-product-image img-responsive">
                        </div>
                        <div v-if="product.status_str" class="box-delivery-judgment-status" :class="getJudgmentStatusClass(product.status_str)">{{ product.status_str }}</div>
                    </td>
                    <td class="text-left">
                      <span>{{ product.itemName }}</span>
                      <br>
                      <span><b>ASIN：</b>{{ product.asin }} / <b>SKU：</b>{{ product.sku }}</span>
                      <br>
                      <span><b>商品ID：</b>{{ product.itemId }} / <b>商品ラベル：</b>{{ product.fnsku }}</span>
                    </td>
                    <td class="text-right text-size-20 font-bold">
                      <span>{{ formatNumber(product.quantity) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="displayData.length === 0" class="table-group text-center text-danger no-data">
              データが見つかりません。
          </div>
        </div>
      </div>
    </div>
    <modal-confirm-delete
      v-if="openModalConfirmDelete"
      @confirm="handleDelete()"
      @close="closeConfirmDeleteModal()"
    />
    <modal-confirm
      v-if="openModalConfirmCoppyDelivery"
      :message="confirmCoppyMessage"
      @confirm="handleCoppy()"
      @close="closeConfirmCoppyModal()"
    />
    <shipping-info-modal
      v-if="openShippingInfoModal"
      :selectShipping="selectItem"
      @close="closeModalShippingInfo"
    />
  </div>
</template>

<script>
import Util from '@/common/utility'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import WarehouseAcrossService from '@/services/warehouseacrossservice'
import ModalConfirmDelete from '@/components/ModalDeleteAlert'
import ModalConfirm from '@/components/ModalConfirm'
import ShippingInfoModal from '@/view/warehouseAcross/components/ShippingInfoModal'
import Pagination from '@/components/PaginationNextPage'
import { mapGetters } from 'vuex'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    DatePicker,
    ModalConfirmDelete,
    ShippingInfoModal,
    ModalConfirm,
    Pagination
  },
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      shippingKbnOption: [
        {
          value: '01',
          label: 'Amazon倉庫へ出荷'
        },
        {
          value: '02',
          label: 'マルチチャネル出荷'
        },
        {
          value: '04',
          label: 'STOCKCREW倉庫へ出荷'
        },
        {
          value: '03',
          label: 'ヤマト運輸倉庫へ出荷'
        }
      ],
      wareHouseStatusOption: ['出荷待ち', '出荷準備中', '出荷済', '登録処理エラー'],
      filter: {
        shippingKbn: ['01', '02', '03', '04'],
        shippingNo: '',
        shippingId: '',
        asin: '',
        sku: '',
        fnsku: '',
        createDate: '',
        warehouseStatus: ['出荷待ち', '出荷準備中', '出荷済', '登録処理エラー'],
        isShowDelete: false
      },
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      },
      defaultData: [],
      pageData: [],
      displayData: [],
      openModalConfirmDelete: false,
      openShippingInfoModal: false,
      openModalConfirmCoppyDelivery: false,
      selectItem: {},
      confirmCoppyMessage: `納品情報を複製します。 <br>
                            よろしければOKボタンを選択してください。 <br>
                            OKボタン選択後は、納品プラン作成画面に遷移します。`,
      totalPage: 1,
      currentPage: 1
    }
  },
  created () {
    this.getShippingList()
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser'
    }),
    paginationStorageKey () {
      return 'acrossShippingList'
    },
    maxRows () {
      return this.$store.getters.getPaginationRow(this.paginationStorageKey)
    }
  },
  methods: {
    async getShippingList () {
      this.loader = this.$loading.show()
      await WarehouseAcrossService.getShippingList()
        .then((response) => {
          this.defaultData = response.data
          this.pageData = this.defaultData.filter(item => {
            return item.isDeleted === this.filter.isShowDelete
          })
          this.sliceDisplayData()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    sliceDisplayData () {
      setTimeout(() => {
        this.totalPage = Math.ceil(this.pageData.length / this.maxRows)
        if (this.totalPage > 0 && this.currentPage > this.totalPage) {
          this.currentPage = 1
        }
        this.displayData = this.pageData.slice((this.currentPage - 1) * this.maxRows, this.currentPage * this.maxRows)
        this.loader && this.loader.hide()
      }, 300)
    },
    handleCoppy () {
      let routeUrl = null
      switch (this.selectedItem.shippingKbn) {
        case '01':
          routeUrl = this.$router.resolve({
            name: 'Warehouse across',
            params: {
              tab: 'shipping',
              subTab: 'amazon-shipping'
            },
            query: {
              shippingId: this.selectedItem.shippingId,
              shippingNo: this.selectedItem.shippingNo
            }
          }).href
          break
        case '02':
          routeUrl = this.$router.resolve({
            name: 'Warehouse across',
            params: {
              tab: 'shipping',
              subTab: 'multi-channel'
            },
            query: {
              shippingId: this.selectedItem.shippingId,
              shippingNo: this.selectedItem.shippingNo
            }
          }).href
          break
        case '03':
          return false
        case '04':
          routeUrl = this.$router.resolve({
            name: 'Warehouse across',
            params: {
              tab: 'shipping',
              subTab: 'stock-crew'
            },
            query: {
              shippingId: this.selectedItem.shippingId,
              shippingNo: this.selectedItem.shippingNo
            }
          }).href
          break
        default:
          return false
      }

      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.list.click_coppy_btn,
        properties: {
          shippingId: this.selectedItem.shippingId,
          shippingNo: this.selectedItem.shippingNo
        }
      }

      EventService.postTrackLog(logParams)
      this.$router.push(routeUrl)
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD') : ''
    },
    handleExpand (id, no) {
      $('#table-group-' + id + '-' + no).addClass('expand')
      $('#btn-expand-' + id + '-' + no).addClass('hidden')
      $('#btn-collapse-' + id + '-' + no).removeClass('hidden')
    },
    handleCollapse (id, no) {
      $('#table-group-' + id + '-' + no).removeClass('expand')
      $('#btn-expand-' + id + '-' + no).removeClass('hidden')
      $('#btn-collapse-' + id + '-' + no).addClass('hidden')
    },
    openModalDeliveyInfo (item) {
      this.selectItem = item
      this.openShippingInfoModal = true
      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.list.click_show_shipping_info_btn,
        properties: {
          shippingNo: item.shippingNo,
          shippingId: item.shippingId
        }
      }
      EventService.postTrackLog(logParams)
    },
    closeModalShippingInfo () {
      this.openShippingInfoModal = false
      $('#shipping-info-modal').modal('hide')
    },
    openConfirmDeleteModal (item) {
      if (item.disableDelete) {
        return false
      }
      this.selectItem = item
      this.openModalConfirmDelete = true
    },
    closeConfirmDeleteModal () {
      this.openModalConfirmDelete = false
      $('#delete-alert').modal('hide')
    },
    openConfirmCoppyModal (item) {
      if (item.disableCopy) {
        return false
      }
      this.selectedItem = item
      this.openModalConfirmCoppyDelivery = true
    },
    closeConfirmCoppyModal () {
      this.openModalConfirmCoppyDelivery = false
      $('#confirm-alert').modal('hide')
    },
    filterShipping (isWriteLog = true) {
      if (isWriteLog) {
        let logParams = {
          name: eventCode.warehouse_across.shipping_tab.list.click_search_btn,
          properties: {}
        }
        EventService.postTrackLog(logParams)
      }

      this.loader = this.$loading.show()

      setTimeout(() => {
        const {
          shippingKbn,
          shippingNo,
          shippingId,
          asin,
          sku,
          fnsku,
          createDate,
          warehouseStatus,
          isShowDelete
        } = this.filter
        const allStatusesSelected = warehouseStatus.length === this.wareHouseStatusOption.length
        const lower = str => str.toLowerCase()
        const matchIncludes = (target, keyword) => lower(target || '').includes(lower(keyword || ''))

        this.pageData = this.defaultData.filter(item => {
          if (!isShowDelete && item.isDeleted) return false

          if (shippingKbn && !shippingKbn.includes(item.shippingKbn)) return false

          if (shippingNo && !matchIncludes(item.shippingNo, shippingNo)) return false

          if (shippingId && !matchIncludes(item.shippingId, shippingId)) return false

          if (asin && !(item.shippingGoods.some(product => matchIncludes(product.asin, asin)))) return false

          if (sku && !(item.shippingGoods.some(product => matchIncludes(product.sku, sku)))) return false

          if (fnsku && !(item.shippingGoods.some(product => matchIncludes(product.fnsku, fnsku)))) return false

          if (createDate && this.formatDate(item.createDate) !== this.formatDate(createDate)) return false

          if (!allStatusesSelected && !warehouseStatus.includes(item.status)) return false

          return true
        })

        this.sliceDisplayData()
      }, 300)
    },
    clearFilter () {
      this.filter = {
        shippingKbn: ['01', '02', '03', '04'],
        shippingId: '',
        asin: '',
        sku: '',
        fnsku: '',
        createDate: '',
        warehouseStatus: ['出荷待ち', '出荷準備中', '出荷済', '登録処理エラー'],
        isShowDelete: false
      }
      this.filterShipping(false)
    },
    getShippingKbnText (shippingKbn) {
      let shippingKbnItem = this.shippingKbnOption.find(item => item.value === shippingKbn)
      return shippingKbnItem.label
    },
    getStatusTextClass (status) {
      if (status === '登録処理エラー') {
        return 'register-processing-error'
      }
      if (status === '登録処理中') {
        return 'register-processing-inprogress'
      }

      return ''
    },
    checkStatus (status) {
      const showStatus = ['出荷待ち', '出荷準備中', '出荷済']
      return showStatus.includes(status)
    },
    getStatusClass (status) {
      if (status === '出荷待ち') {
        return 'awaiting-shipping'
      }
      if (status === '出荷準備中') {
        return 'preparing-to-ship'
      }
      if (status === '出荷済') {
        return 'shipped'
      }
    },
    getJudgmentStatusClass (status) {
      let statusStop = ['停止中', '削除済']
      let statusSuccess = ['出品中']
      let statusWarning = ['未審査', '審査中']
      let statusDanger = ['出品NG', '審査NG']
      if (!status) {
        return ''
      }
      if (statusSuccess.includes(status)) {
        return 'judgment-status-success'
      }
      if (statusWarning.includes(status)) {
        return 'judgment-status-warning'
      }
      if (statusDanger.includes(status)) {
        return 'judgment-status-danger'
      }
      if (statusStop.includes(status)) {
        return 'judgment-status-stop'
      }
    },
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    handleEdit (item) {
      if (item.disableEdit || item.shippingKbn === '01') {
        return false
      }

      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.list.click_edit_btn,
        properties: {
          shippingNo: item.shippingNo,
          shippingId: item.shippingId
        }
      }
      EventService.postTrackLog(logParams)

      let subTab = ''

      switch (item.shippingKbn) {
        case '02':
          subTab = 'edit-multi-channel'
          break
        case '03':
          subTab = 'edit-yamato-channel'
          break
        case '04':
          subTab = 'edit-stock-crew'
          break
        default:
          break
      }

      this.$router.push({
        name: 'Warehouse across',
        params: {
          tab: 'shipping',
          subTab: subTab
        },
        query: {
          shippingNo: item.shippingNo,
          shippingId: item.shippingId
        }
      })
    },
    handleDelete () {
      if (this.selectItem.disableDelete || this.selectItem.shippingKbn === '01') {
        this.closeConfirmDeleteModal()
        return false
      }
      if (this.selectItem.shippingKbn === '02') {
        this.deleteShippingMultichannel()
      }

      if (this.selectItem.shippingKbn === '03') {
        this.deleteShippingYamato()
      }

      if (this.selectItem.shippingKbn === '04') {
        this.deleteShippingSc()
      }
    },
    deleteData (response) {
      if (response.data.shippingId && response.data.shippingNo) {
        this.defaultData = this.defaultData.map(item => {
          if (item.shippingId === response.data.shippingId && item.shippingNo === response.data.shippingNo) {
            return {
              ...item,
              status: '削除済',
              isDeleted: true,
              disableEdit: true,
              disableDelete: true
            }
          }
          return item
        })
        this.pageData = this.pageData.filter(item => {
          if (item.shippingId === response.data.shippingId && item.shippingNo === response.data.shippingNo) {
            item.status = '削除済'
            item.isDeleted = true
            item.disableEdit = true
            item.disableDelete = true
          }
          if (!this.filter.isShowDelete && item.isDeleted) return false
          return true
        })
        this.sliceDisplayData()
      }
    },
    async deleteShippingMultichannel () {
      this.loader = this.$loading.show()
      let params = {
        shippingNo: this.selectItem.shippingNo,
        shippingId: this.selectItem.shippingId
      }

      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.list.click_delete_btn,
        properties: params
      }
      EventService.postTrackLog(logParams)

      await WarehouseAcrossService.deleteShippingMultichannel(params)
        .then((response) => {
          this.deleteData(response)
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
          this.loader && this.loader.hide()
        })
        .finally(() => {
          this.closeConfirmDeleteModal()
        })
    },
    async deleteShippingYamato () {
      this.loader = this.$loading.show()
      let params = {
        shippingNo: this.selectItem.shippingNo,
        shippingId: this.selectItem.shippingId
      }

      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.list.click_delete_btn,
        properties: params
      }
      EventService.postTrackLog(logParams)

      await WarehouseAcrossService.deleteShippingYamato(params)
        .then((response) => {
          this.deleteData(response)
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
          this.loader && this.loader.hide()
        })
        .finally(() => {
          this.closeConfirmDeleteModal()
        })
    },
    async deleteShippingSc () {
      this.loader = this.$loading.show()
      let params = {
        shippingNo: this.selectItem.shippingNo,
        shippingId: this.selectItem.shippingId
      }

      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.list.click_delete_btn,
        properties: params
      }
      EventService.postTrackLog(logParams)

      await WarehouseAcrossService.deleteShippingSc(params)
        .then((response) => {
          this.deleteData(response)
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
          this.loader && this.loader.hide()
        })
        .finally(() => {
          this.closeConfirmDeleteModal()
        })
    },
    updateCurrentPage (val) {
      this.loader = this.$loading.show()
      this.currentPage = val
      this.sliceDisplayData()
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.warehouse_across.shipping_tab.list.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  },
  watch: {
    maxRows () {
      this.loader = this.$loading.show()
      this.sliceDisplayData()
    }
  }
}
</script>
<style scoped>
.judgment-status-stop {
  background-color: #a6a6a6;
  color: #f2f2f2;
}
.judgment-status-danger {
  background-color: #c00000;
  color: #fff;
}
.panel-body {
  padding: 10px 0;
}
.control-label {
  color: #595959;
}
.filter {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ccc;
  height: auto;
  box-sizing: content-box;
}
.form-check-label {
  padding-left: 5px;
  font-weight: unset;
}
.table-outter {
  margin-top: 5px;
  /* overflow-x: auto;
  overflow-y: auto; */
  overflow: hidden;
  width: 1440px;
  padding-bottom: 90px;
}
.table-header {
  table-layout: fixed;
  border: 1px solid #ccc;
  position: sticky;
  top: 0;
  z-index: 1;
  background: #deebf7;
}
.table-header th {
  padding: 5px 10px;
  margin: 0 10px;
  color: #595959;
  background: #deebf7;
}

.table-header td {
  padding: 5px;
  height: 50px;
}
.text-danger {
  font-weight: unset;
}
.btn.disabled {
  background-color: #efefef;
  color: #000;
  border: 1px solid #ccc;
}
.table-item th{
  background-color: #fff;
  color: #000;
  font-weight: bold;
  border: none;
  border-bottom: 2px solid #008cc6;
  padding: 0 5px;
  z-index: -1;
}
.table-item td {
  border-bottom: 1px solid #ccc;
}
.table-group {
  background-color: #fff;
  border: 1px solid #ccc;
  vertical-align: middle;
}
.table-group td {
  padding: 5px 10px;
  height: 50px;
}
.table-group > tr.collapse td {
  background-color: red;
}
.table-group.expand {
  background-color: #deebf7;
}
.table-group.deleted {
  background-color: #ccc;
}
.btn-expand {
  color: #008cc6;
  border: 1px solid #008cc6;
  background-color: #fff;
}
.btn-collapse {
  color: #000;
  background-color: #bfbfbf;
  border: 1px solid #ccc;
}
.box-selected-product-image {
  margin: 0 auto;
}
.shipping-status {
  width: 80px;
  height: 10px;
  border-radius: 4px;
  border: 1px solid #bfbfbf;
}
.awaiting-shipping {
  background-color: #f2f2f2;
}
.preparing-to-ship {
  background-color: #ffd428;
}
.shipped {
  background-color: #70ad47;
}
.register-processing-error {
  padding: 2px 5px;
  border-radius: 5px;
  color: #ff0000;
  background-color: #fff;
}
.register-processing-inprogress {
  padding: 2px 5px;
  border-radius: 5px;
  color: #a6a6a6;
  background-color: #fff;
}
.judgment-status-not-listed {
  color: #f2f2f2;
  background-color: #a6a6a6;
}
.no-data {
  background-color: rgb(242, 222, 222);
}
.w-280 {
  width: 280px !important;
}
.w-300 {
  width: 300px !important;
}
.w-270 {
  width: 270px !important;
}
.w-210 {
  width: 210px !important;
}
.mx-datepicker {
  width: 100%;
}
.dropdown-menu {
  min-width: 100px;
  max-width: 110px;
  left: unset !important;
  right: 0;
  font-size: 14px;
  padding: unset;
}
.dropdown-menu li {
  height: 30px;
  padding: 3px 5px;
  line-height: 24px;
}
.dropdown-menu li:hover {
  cursor: default;
  background-color: #deebf7;
}
.dropdown-menu > li.disabled {
  color: #bfbfbf;
  pointer-events: none;
}
#shipping-status-inquiry {
  overflow-y: auto;
}
@media (max-width: 1920px) {
  .table-outter {
    width: 1440px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/ShippingStatusInquiry.vue